<mat-form-field
  [class.light-form-field]="lightFormField"
  data-cy="job-type-select">
  <mat-label>{{
    label || ("jobType" | i18n) || "Jobtype" | titlecase
  }}</mat-label>

  <mat-select
    [ngModel]="selectedJobType"
    (ngModelChange)="onSelectionChange($event)"
    [disabled]="disabled"
    [required]="required"
    name="jobTypeSelect"
    [attr.data-cy]="'job-type-value-' + selectedJobType"
    data-cy="job-type-select-input">
    <mat-option
      *ngFor="let jobType of jobTypeEnum | enumToArray"
      [value]="jobTypeEnum[jobType]"
      [attr.data-cy]="'job-type-select-option-' + jobTypeEnum[jobType]">
      {{ ("jobTypeEnum." + jobTypeEnum[jobType] | i18n) || jobType }}
    </mat-option>
  </mat-select>
</mat-form-field>
